import t from "react";
import n from "prop-types";
import { I as i } from "./Icon-ByeAHRM4.es.js";
import { D as a } from "./DateTextInput-MszCKoMO.es.js";
import { a as r } from "./propTypes-DVvgo52A.es.js";
import { d as s, p as l } from "./utils-B8CGXZ5v.es.js";
import './DateInputRow.css';const d = "#000", m = "DateInputRow-module__container___-ZC-f", u = "DateInputRow-module__icon___DFCdp", o = {
  iconColor: d,
  container: m,
  icon: u
}, c = (e) => /* @__PURE__ */ t.createElement("div", { className: o.container }, /* @__PURE__ */ t.createElement(
  a,
  {
    label: "From:",
    value: s(e.start, e.showDays),
    placeholder: e.showDays ? "mm/dd/yyyy" : "mm/yyyy",
    large: e.showDays,
    error: e.startWarning,
    onFocus: () => e.onSetFocus("start"),
    onSet: e.onSetStart,
    focused: !0
  }
), /* @__PURE__ */ t.createElement(
  i,
  {
    className: o.icon,
    color: o.iconColor,
    size: l(20),
    name: "pointed_arrow_right"
  }
), /* @__PURE__ */ t.createElement(
  a,
  {
    label: "To:",
    value: s(e.end, e.showDays),
    placeholder: e.showDays ? "mm/dd/yyyy" : "mm/yyyy",
    large: e.showDays,
    error: e.endWarning,
    onFocus: () => e.onSetFocus("end"),
    onSet: e.onSetEnd,
    focused: !1
  }
));
c.propTypes = {
  start: r,
  end: r,
  showDays: n.bool.isRequired,
  onSetStart: n.func.isRequired,
  onSetEnd: n.func.isRequired,
  onSetFocus: n.func.isRequired,
  startWarning: n.string,
  endWarning: n.string
};
c.defaultProps = {
  start: null,
  end: null,
  startWarning: null,
  endWarning: null
};
export {
  c as D
};
